import HighlightText from '~/components/shared/HighlightText';
import {
  SearchHeader,
  SearchQuery,
  SearchFooter,
  DiscardSelectionDialog,
} from '~/components/shared/Modals/SearchParts';
import React, {useState, useRef, useCallback} from 'react';
import {View, ActivityIndicator, ScrollView} from 'react-native';
import {Divider} from 'react-native-paper';
import debounce from 'lodash/debounce';
import sy from '~/styles';
import {Checkbox, Pressable, Modal} from '~/components/controls';
import PropTypes from 'prop-types';
const SearchRobCodeModal = ({codes, onSearch, onDismiss, onAdd}) => {
  const [selection, setSelection] = useState([]);
  const [results, setResults] = useState([]);
  const [highlightSearchText, setHighlightSearchText] = useState('');
  const [prefix, setPrefix] = useState('');
  const [searching, setSearching] = useState(false);
  const [showCancelAddDialog, setShowCancelAddDialog] = useState(false);
  const searchTextRef = useRef(null);
  const onClose = () => {
    if (selection.length) {
      setShowCancelAddDialog(true);
    } else {
      onDismiss();
    }
  };
  const onPrefixChange = useCallback(
    debounce(async (value) => {
      if (value.length < 1) {
        setResults([]);
        return;
      }
      setSearching(true);
      try {
        const result = await onSearch(value);
        if (searchTextRef.current?.value === value) {
          setResults(result);
        }
      } finally {
        setSearching(false);
      }
    }, 500),
    [],
  );
  return (
    <>
      <Modal visible={true} onDismiss={onDismiss}>
        <SearchHeader
          title="ROB activiteit toevoegen"
          onClose={onClose}
          closeStyle={[sy['p-4'], sy['pr-8']]}
        />
        <SearchQuery
          prefix={prefix}
          searchTextRef={searchTextRef}
          onChangeText={(value) => {
            onPrefixChange.cancel();
            onPrefixChange(value);
            setHighlightSearchText(value);
            setPrefix(value);
          }}
        />
        <Divider style={sy['bg-gray88']} />
        <ScrollView style={sy['bg-gray95']}>
          {searching ? (
            <View style={[sy['p-4']]}>
              <ActivityIndicator size="large" color="#231fda" />
            </View>
          ) : (
            results.map((result, index, arr) => (
              <View style={sy['bg-white']} key={result.rob_code}>
                <View style={[sy['flex-row'], sy['p-4'], sy['gap-8']]}>
                  <Pressable
                    disabled={codes.includes(result.rob_code)}
                    onPress={() => {
                      if (
                        selection.some(
                          (item) => item.rob_code === result.rob_code,
                        )
                      ) {
                        setSelection(
                          selection.filter(
                            (item) => item.rob_code !== result.rob_code,
                          ),
                        );
                      } else {
                        setSelection([...new Set([...selection, result])]);
                      }
                    }}>
                    <Checkbox
                      style={{
                        width: 'auto',
                      }}
                      disabled={codes.includes(result.rob_code)}
                      checked={
                        selection.some(
                          (item) => item.rob_code === result.rob_code,
                        ) || codes.includes(result.rob_code)
                      }
                    />
                  </Pressable>
                  <View style={[sy['flex-1']]}>
                    <View
                      style={{
                        display: 'block',
                      }}>
                      <HighlightText
                        highlightedStyle={[
                          {
                            lineHeight: 16,
                          },
                          sy.mediumBold,
                        ]}
                        text={`${result.rob_code} · ${result.description}`}
                        highlight={highlightSearchText}
                      />
                    </View>
                  </View>
                </View>
                {index < arr.length - 1 && (
                  <Divider style={[sy['bg-gray95'], sy['ml-18']]} />
                )}
              </View>
            ))
          )}
        </ScrollView>
        <Divider style={sy['bg-gray88']} />
        <SearchFooter selection={selection} onAdd={onAdd} />
      </Modal>
      <DiscardSelectionDialog
        showCancelAddDialog={showCancelAddDialog}
        setShowCancelAddDialog={setShowCancelAddDialog}
        onDismiss={onDismiss}
      />
    </>
  );
};
SearchRobCodeModal.propTypes = {
  codes: PropTypes.any,
  onSearch: PropTypes.any,
  onDismiss: PropTypes.any,
  onAdd: PropTypes.any,
};
export default SearchRobCodeModal;
